// import React, { Fragment, FunctionComponent } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faUmbrellaBeach } from "@fortawesome/free-solid-svg-icons";
// import { Graphics, Description } from "../styles/agency-income-metrics-styles";

// const Travel: FunctionComponent<unknown> = () => (
//   <Fragment>
//     <Graphics>
//       <FontAwesomeIcon icon={faUmbrellaBeach} />
//     </Graphics>
//     <Description>
//       This could buy you: <br /> <span>a luxury holiday</span>!
//     </Description>
//   </Fragment>
// );

// export default Travel;
